<template>
  <div class="settings">
    <h2>設定</h2>
    <p>
      3連続クリック時タイマーリセット機能の連続判定しきい値（ミリ秒）
    </p>
    <input
      type="number"
      :value="cct"
      @input="changeCCT"
    >
  </div>
</template>

<script>
export default {
  name: 'SettingsComponent',
  props: {
    cct: {
      type: Number,
      required: true
    }
  },
  emits: ['updatecct'],
  data: function(){
      return {
      }
  },
  computed: {
    computedCCT: {
      get() {
        return this.cct
      },
      set(newVal) {
        this.$emit('updatecct', newVal)
      }
    }
  },
  methods: {
      changeCCT: function(event) {
          this.computedCCT = event.target.value
      }
  }
}
</script>